import { useMemo } from "react"
import styled from "@emotion/native"
import { Spacing, Text } from "../"
import { ListItem } from "../ListItem.tsx"
import { useCurrencyFormatter } from "../../hooks"
import RightCaret from "../../assets/RightCaret.svg"
import ArrowUp from "../../assets/ArrowUp.svg"
import CardIcon from "../../assets/card-icon.svg"

type TransactionListItemProps = {
  id: string
  name?: string
  logoColor?: string
  amount: { value: number; currencyCode: string }
  accountFourDigits?: string
  description?: string
  isReimbursed: boolean
  onPress: (id: string) => void
  paymentMethod: string
}

export function TransactionListItem(props: TransactionListItemProps) {
  const { id, name, logoColor, amount, accountFourDigits, description, onPress, paymentMethod } =
    props
  const { formatAmount } = useCurrencyFormatter()

  const itemDescription = useMemo(() => {
    if (description) {
      return description
    }
    if (accountFourDigits) {
      return `Account ending in ${accountFourDigits}`
    }
  }, [accountFourDigits, description])

  return (
    <ListItem
      leftElement={
        <LeftIconContainer>
          <ArrowUp />
        </LeftIconContainer>
      }
      rightElement={
        <RightElementContainer>
          {paymentMethod == "Card" && (
            <>
              <CardIcon />
              <Spacing right={10} />
            </>
          )}
          <Text fontFamily="IBMPlexSans-Medium" fontSize={18} lineHeight={26}>
            {formatAmount(amount)}
          </Text>
          <RightCaret />
        </RightElementContainer>
      }
      onPress={() => {
        if (paymentMethod !== "Card") {
          onPress(id)
        }
      }}
      description={itemDescription}
      descriptionTextProps={{
        fontSize: 16,
        lineHeight: 24,
        color: "grayscale700",
      }}
      logoColor={logoColor}
      name={name}
      nameTextProps={{
        fontSize: 18,
        lineHeight: 26,
        fontFamily: "IBMPlexSans-Medium",
      }}
    />
  )
}

const LeftIconContainer = styled.View`
  width: 46px;
  height: 46px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.transactionList.leftIconBackgroundColor};
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`

const RightElementContainer = styled.View`
  align-items: center;
  flex-direction: row;
`
